var Webflow = Webflow || [];
Webflow.push(function () {
  // DOMready has fired
  // May now use jQuery and Webflow api

  // gsap code here!
  gsap.registerPlugin(ScrollTrigger);

  const heroSection = document.querySelector('.section_hero');
  const heroContent = document.querySelector('.section_hero .container-large');
  const heroVideo = document.querySelector('.section_hero video');
  const heroBuoy = document.querySelector('.section_hero .layout16_image');

  gsap.set(heroVideo, { autoAlpha: 1 });
  gsap.set(heroSection.querySelector('.layout40_background-video-wrapper'), { position: 'fixed' });
  gsap.set(heroContent, { position: 'relative', zIndex: 1, autoAlpha: 1 });

  //gsap.to(heroVideo, { scrollTrigger: heroSection, autoAlpha: .8, duration: 3, ease: 'power2.inOut' });
  //gsap.to(heroContent, { scrollTrigger: heroSection, autoAlpha: .8, duration: 2, delay: 1, ease: 'power2.inOut' });

  // Create timeline for hero animation
  const heroTl = gsap.timeline({
    scrollTrigger: {
      trigger: heroSection,
      scrub: true,
      start: 'top top',
      end: () => `+=${heroSection.offsetHeight}`, // Duration based on section height
      markers: false,
      normalizeScroll: true,
    },
  });

  // Fade in video and content
  heroTl
    .to(
      heroVideo,
      { scale: 1.2, autoAlpha: 0, yPercent: -10, duration: 1, ease: 'power2.inOut' },
      0
    )
    .to(heroContent, { autoAlpha: 0, duration: 0.5, ease: 'power2.in' }, '<'); // Fade out text
  // Buoy animation
  gsap.fromTo(
    heroBuoy,
    { y: 10 },
    { y: -25, duration: 3, ease: 'power2.inOut', repeat: -1, yoyo: true }
  );

  // Select all sections
  const contentSections = document.querySelectorAll('.section_layout40');

  contentSections.forEach((section, index) => {
    const content = section.querySelector('.container-large');
    const video = section.querySelector('video');
    const nextSection = contentSections[index + 1];
    const nextVideo = nextSection?.querySelector('video');
    const isLastSection = index + 1 === contentSections.length;

    gsap.set(content, { opacity: 0, position: 'relative', zIndex: 2 });
    gsap.set(video, { autoAlpha: 0 });
    gsap.set(section.querySelector('.layout40_background-video-wrapper'), { position: 'fixed' });

    const st = ScrollTrigger.create({
      trigger: section,
      start: 'top center', // Start pinning at the top of the viewport
      toggleActions: 'play pause resume reset',
      preventOverlaps: true,
      fastScrollEnd: true,
      normalizeScroll: true,
      end: () => `+=${section.offsetHeight}`, // Duration based on section height
      onEnter: () => {
        gsap.to(video, { autoAlpha: 1, duration: 0.5, ease: 'power2.inOut' }); // Fade in current video
        gsap.to(content, { autoAlpha: 1, duration: 0.5, ease: 'power2.inOut' }); // Fade in content
      },
      onEnterBack: () => {
        gsap.to(video, { autoAlpha: 1, duration: 0.5, ease: 'power2.inOut' }); // Fade in current video
        gsap.to(content, { autoAlpha: 1, duration: 0.5, ease: 'power2.inOut' }); // Fade in content
      },
      onLeave: () => {
        if (!isLastSection) {
          gsap.to(video, { autoAlpha: 0, duration: 0.5, ease: 'power2.inOut' }); // Fade out current video
          gsap.to(content, { autoAlpha: 0, duration: 0.5, ease: 'power2.inOut' }); // Fade out current video
        }
      },
      onLeaveBack: () => {
        gsap.to(video, { autoAlpha: 0, duration: 0.5, ease: 'power2.inOut' }); // Fade out current video
        gsap.to(content, { autoAlpha: 0, duration: 0.5, ease: 'power2.inOut' }); // Fade out current video
      },
    });
  });

  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis();

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
});
